import './Price.scss'

import React from 'react'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
const styles = style('price')

type PriceType = {
	isFree?: boolean
	discounted?: boolean
}

export const Price: React.FC<PriceType> = ({isFree, discounted, children}) => {
	return (
		<span className={styles.mod({free: isFree, discounted})}>{children}</span>
	)
}
